import { animations } from "./animations"
import { blurs } from "./blurs"
import { borders } from "./borders"
import { breakpoints } from "./breakpoints"
import { colors } from "./colors"
import { fontSizes } from "./font-sizes"
import { fontWeights } from "./font-weights"
import { fonts } from "./fonts"
import { gradients } from "./gradients"
import { letterSpacings } from "./letter-spacings"
import { lineHeights } from "./line-heights"
import { radii } from "./radii"
import { shadows } from "./shadows"
import { sizes } from "./sizes"
import { spaces } from "./spaces"
import { transitions } from "./transitions"
import { zIndices } from "./z-indices"

export const tokens = {
  animations,
  blurs,
  borders,
  breakpoints,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  gradients,
  letterSpacings,
  lineHeights,
  radii,
  shadows,
  sizes,
  spaces,
  transitions,
  zIndices,
}
